/** 张三 → 张*, 欧阳娜娜 → 欧***: the board is on a wall customers see. */
export const maskCustomerName = (name: string | null | undefined) => {
  const characters = Array.from(name?.trim() ?? '');
  if (!characters.length) return null;
  return characters[0] + '*'.repeat(Math.max(1, characters.length - 1));
};
